import { createFileRoute, redirect } from '@tanstack/react-router';

import { canViewCustomPartOffers, isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// `/parts/custom/details/:id`, where links to a custom part go, has no tab of its own: it opens the first tab the user
// may open, offers or else used in. Each tab checks its own access. A user who may open neither stays here, on the
// custom part without a tab.
export const Route = createFileRoute('/_authenticated/parts/custom/details/$customPartSpecificationId/')({
    staticData: { access: { permissions: ['view:part_library'] }, chrome: 'home' } satisfies PageStaticData,
    beforeLoad: ({ context, params }) => {
        if (canViewCustomPartOffers(context.session)) {
            throw redirect({ to: '/parts/custom/details/$customPartSpecificationId/offers', params, replace: true });
        }
        if (isInternalUser(context.session)) {
            throw redirect({ to: '/parts/custom/details/$customPartSpecificationId/used-in', params, replace: true });
        }
    },
});
